import { HttpErrorResponse } from '@angular/common/http';
import { Component, computed, input, OnChanges, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
  ],
  selector: 'file-upload-status',
  styleUrls: ['./file-upload-status.component.css'],
  templateUrl: './file-upload-status.component.html',
})
export class FileUploadStatusComponent implements OnChanges {
  readonly progressBarItem = input<any>();
  readonly progress = input(0);
  readonly cancelUploadId = output<string>();
  readonly $errorMessage = computed(() => {
    const error = this.progressBarItem()?.error;
    if (typeof error === 'string') {
      return error;
    }

    if (error instanceof HttpErrorResponse) {
      const detail = error.error?.detail ?? error.error?.message;
      const message = typeof detail === 'string' ? detail : error.message;
      return `Error: ${message}`;
    }

    return '';
  });

  ngOnChanges() {
    this.progressBarItem().newUpload = true;
  }

  onCancelUpload(document: { id: string }) {
    this.cancelUploadId.emit(document.id);
  }
}
